module.exports = __webpack_public_path__ + "img/bottomsheet.70202375.svg";